import React from "react";
import styled from "styled-components";
import theme from "../style/theme";
import { Link } from "gatsby";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 80%;
  margin: 8rem auto;
  padding: 3rem 4rem;
  box-sizing: border-box;
  //border: 3px solid ${theme.palette.primary.main};
  background-color: ${theme.palette.primary.main};
  //&:before {
  //  position: absolute;
  //  content: "";
  //  top: -2rem;
  //  left: 50%;
  //  height: 4rem;
  //  display: block;
  //  margin: 0 auto;
  //  text-align: center;
  //  border-left: 1px solid ${theme.palette.primary.main};
  //  border-top: none;
  //  width: 1px;
  //}
  &:before, &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    width: 1px;
    height: 2rem;
    display: block;
    margin: 0 auto;
    text-align: center;
  }
  &:before {
    border-right: 1px solid ${theme.palette.white};
    top: 0;
  }
  &:after {
    border-right: 1px solid ${theme.palette.primary.main};
    top: -2rem;
  }
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 4rem auto;
    padding: 2rem 2rem 0rem;
  }
`

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 30%;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 100%;
  }
`

const ContactTitle = styled.h2`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${theme.palette.white};
  font-size: 2rem;
  font-family: ''Montserrat'', serif;
  font-style: normal;
  font-weight: 100;
  letter-spacing: .13em;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    text-align: center;
  }
`

const ContactDescription = styled.span`
  display: inline-block;
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${theme.palette.white};
  font-size: 0.8rem;
  letter-spacing: .06em;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    text-align: center;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 100%;
  }
`

const Button = styled(Link)`
  position: relative;
  display: block;
  width: 100%;
  margin: 2rem 0;
  padding: 1rem 1rem;
  text-decoration: none;
  text-align: center;
  letter-spacing: .06em;
  box-sizing: border-box;
  color: ${theme.palette.white};
  background-color: ${theme.palette.primary.main};
  border: 1px solid ${theme.palette.white};
  transition: .5s;
  &:after {
    position: absolute;
    right: 0;
    padding: 0 1rem;
    content: '>';
  }
  &:hover {
    color: ${theme.palette.primary.main};
    background-color: ${theme.palette.white};
    border: 1px solid ${theme.palette.primary.main};
  }
`

const isExternalUrl = url => url && url.startsWith("http");

export const ContactButton = ({ to, breakpoints, title="お問い合わせ", description="お問い合わせはこちら" }) => {
  return (
    <Wrapper breakpoints={breakpoints}>
      <ContactWrapper breakpoints={breakpoints}>
        <ContactTitle breakpoints={breakpoints}>Contact</ContactTitle>
        <ContactDescription breakpoints={breakpoints}>{description}</ContactDescription>
      </ContactWrapper>
      <ButtonWrapper breakpoints={breakpoints}>
        {
          isExternalUrl(to) ? (
            <Button
              href={to}
              rel="noopener noreferrer"
              target="_blank"
            >{title}</Button>
          ) : (
            <Button to={to}>{title}</Button>
          )
        }
      </ButtonWrapper>
      <ContactWrapper></ContactWrapper>
    </Wrapper>
  )
}
